import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { db } from './firebase';

export async function getTgBotUser(docId) {
  const docRef = doc(db, 'tg-bot-users', docId);
  const snapshot = await getDoc(docRef);
  if (!snapshot.exists()) return null;
  return { id: snapshot.id, ...snapshot.data() };
}

export async function getAllTgBotUsers() {
  const usersRef = collection(db, 'tg-bot-users');
  const snapshot = await getDocs(usersRef);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
}
